import { render, staticRenderFns } from "./ProductSelectorMultiManager.vue?vue&type=template&id=47c3c9f5&scoped=true"
import script from "./ProductSelectorMultiManager.vue?vue&type=script&lang=js"
export * from "./ProductSelectorMultiManager.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectorMultiManager.vue?vue&type=style&index=0&id=47c3c9f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3c9f5",
  null
  
)

export default component.exports